import React, { Component } from 'react';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import BlankPage from '../components/css/dark/img/page-not-found.png';
import RxBlankPage from '../components/css/dark/img/rx-page-not-found.png';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { Helmet } from "react-helmet";

class PageNotFound extends Component {

    constructor(props) {
        super(props);
        try {
            this.state = {
                userdata: JSON.parse(localStorage.getItem('user')),
            };
        }
        catch (error) { }
    }
    componentDidMount(event) {
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    render() {
        var is_UserLogged_In = false;
        try {
            if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}")
                is_UserLogged_In = false;
            else
                is_UserLogged_In = true;
        }
        catch (err) {
        }
        return (
            <div className="page-not-found">                
                {is_UserLogged_In ?
                    <div>
                        <Helmet>
                            <title>Page Not Found</title>
                        </Helmet>
                        <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                        <Header />
                        <Sidebar />
                    </div> : null
                }
                <div className={is_UserLogged_In ? "tool-section report" : "tool-section report remove-gap"}>
                    <div className="blank-section">
                        <div className="adjust">
                            <img className="not-found" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxBlankPage : BlankPage} alt="pageNotFound" />
                            <h2>404 Error <span>We can’t find the page you’re looking for.</span></h2>
                            <NavLink to="/dashboard" activeClassName="active-change"><span className="menu-text submenu-open">Take me Home</span></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PageNotFound;